export function formatLocalCurrency(v:number|undefined|null){
    let value=v?v:0;
    return `R$ ${value.toLocaleString('pt-br', {style: 'decimal', maximumFractionDigits: 2,minimumFractionDigits:2})}`;
}